import { useRecordDetailContainer } from "./RecordDetailContainer.hook";
import RecordDetail from "../components/RecordDetail";
import PageWrapper from "../../common/components/PageWrapper";

export default function RecordDetailContainer() {
  const {
    models: { recordId },
  } = useRecordDetailContainer();

  return (
    <PageWrapper>
      <RecordDetail recordId={recordId} />
    </PageWrapper>
  );
}
